import { render, staticRenderFns } from "./choosestudent.vue?vue&type=template&id=7265e8be&scoped=true"
import script from "./choosestudent.vue?vue&type=script&lang=js"
export * from "./choosestudent.vue?vue&type=script&lang=js"
import style0 from "./choosestudent.vue?vue&type=style&index=0&id=7265e8be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7265e8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7265e8be')) {
      api.createRecord('7265e8be', component.options)
    } else {
      api.reload('7265e8be', component.options)
    }
    module.hot.accept("./choosestudent.vue?vue&type=template&id=7265e8be&scoped=true", function () {
      api.rerender('7265e8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/choosestudent.vue"
export default component.exports